import { ComponentInterface, Entity } from '@goodboydigital/odie';

import { BaseEntity } from '../entities/BaseEntity';
import { Game } from '../Game';

export class BlinkComponent implements ComponentInterface
{
    public entity!: BaseEntity;
    public blinking = false;
    public count = -1;

    private addedToPhysicsFixedUpdate = false;
    private blinkDispatch?: any;
    private vanishDispatch?: any;

    public addedToEntity(entity: Entity): void
    {
        this.entity = entity as BaseEntity;
    }

    public physicsFixedUpdate(): void
    {
        if (!this.blinking) return;
        if (!this.count--)
        {
            this.count = 6;
            const a = this.entity.view.alpha === 1 ? 0.05 : 1;

            this.entity.view.alpha = a;
        }
    }

    private addToPhysicsUpdate(): void
    {
        if (this.addedToPhysicsFixedUpdate) return;
        this.addedToPhysicsFixedUpdate = true;

        const game = this.entity.scene as Game;

        game.physics.physicsFixedUpdateRunner.add(this as any);
    }

    public startBlinking(duration: number, delay = 0): void
    {
        if (this.blinking) return;

        const game = this.entity.scene as Game;

        if (delay)
        {
            this.blinkDispatch = game.physics.timer.dispatchAfter(delay, () => this.startBlinking(duration));

            return;
        }

        this.addToPhysicsUpdate();
        this.blinking = true;
        this.count = 1;

        if (duration)
        {
            this.blinkDispatch = game.physics.timer.dispatchAfter(duration, () => this.stopBlinking());
        }
    }

    public stopBlinking(): void
    {
        const game = this.entity.scene as Game;

        if (this.blinkDispatch) game.physics.timer.removeScheduledItem(this.blinkDispatch);
        this.blinkDispatch = null;
        this.blinking = false;
        this.entity.view.alpha = 1;
        this.count = -1;
    }

    public vanish(delay = 0): void
    {
        const game = this.entity.scene as Game;

        if (delay)
        {
            this.vanishDispatch = game.physics.timer.dispatchAfter(delay, () => this.vanish());

            return;
        }

        this.stopBlinking();
        this.entity.view.renderable = false;
    }

    public showUp(): void
    {
        const game = this.entity.scene as Game;

        if (this.vanishDispatch) game.physics.timer.removeScheduledItem(this.vanishDispatch);
        this.vanishDispatch = null;
        this.entity.view.renderable = true;

        this.stopBlinking();
    }
}
